export default Object.freeze({
	ADMIN: 'admin',
	GENERAL: 'general',
	ADMINISTRATOR: 'administrator',
	NO_ACCESS: 'noaccess',
});
